import { subscribeToAvailableProjects } from "../serverComs"
import { renderReactComponentInElement } from "$utils/react";
import { Connect } from '../views/Connect'

let checkLoadedCorrectlyInterval = undefined;

checkLoadedCorrectlyInterval = setInterval(() => {
    location.reload();
}, 2000)

let reactRoot = undefined;

subscribeToAvailableProjects((infoProjects) => {
    clearInterval(checkLoadedCorrectlyInterval);
    reactRoot = renderReactComponentInElement(Connect, 'root', {infoProjects}, reactRoot)
});